import BaseCefCommercialService from "./base.service";
import { CefVersion } from "./constants";

export type LookupsResponse = {
    lookups: Lookups
}

export type Lookups = {
    errorCodes: ErrorCodeLookup[]
}

export type ErrorCodeLookup = {
    errorCode: string,
    errorDescription: string,
    causeDescription: string,
    solutionDescription: string
}

class LookupService extends BaseCefCommercialService {
    constructor() {
        super("");
        this.setBaseUrl(`CEFLookup/${CefVersion}`);
    }

    getErrorCodes() {
        return this.createPromiseRequest("lookups?lookupNames=errorCodes").get<LookupsResponse>();
    }
}

export default LookupService;
